export default "__VITE_ASSET__QvR7KqAT__"